import { render, staticRenderFns } from "./section-time-period-chart.vue?vue&type=template&id=3b28cb1b&scoped=true"
import script from "./section-time-period-chart.vue?vue&type=script&lang=js"
export * from "./section-time-period-chart.vue?vue&type=script&lang=js"
import style0 from "./section-time-period-chart.vue?vue&type=style&index=0&id=3b28cb1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b28cb1b",
  null
  
)

export default component.exports